import React from "react";
import StudentChatMessagePage from "@/pages/student/StudentChatMessagePage";

/**
 * Business chat thread — reuses the student message thread (socket join, live
 * messages, presence) and only points its back arrow at the portal room list.
 */
const BusinessChatMessagePage: React.FC = () => (
  <StudentChatMessagePage backPath="/portal/messages" />
);

export default BusinessChatMessagePage;
